export default __webpack_public_path__ + "static/media/wall-pids-1.1821016f.jpg";